import React from 'react';
import { Search, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const SearchTagDocuments = () => {
  return (
    <div className="search-tag-documents" style={{ fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <Link 
            to="/collaboration/documents" 
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-4"
          >
            <ArrowLeft size={20} className="mr-2" />
            Back to Document Library
          </Link>
          <h1 className="text-3xl font-bold text-gray-900">Search & Tag Documents</h1>
          <p className="text-gray-600 mt-2">
            Find documents quickly with intelligent search and tagging.
          </p>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="text-center py-12">
            <div className="bg-green-100 p-4 rounded-2xl w-fit mx-auto mb-6">
              <Search size={48} className="text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Document Search</h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Advanced document search with intelligent tagging and metadata filtering. 
              This feature will be available in v1.1.
            </p>
            
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-yellow-800 text-sm">
                <strong>Coming Soon:</strong> AI-powered document search with intelligent tagging, 
                content-based search, and automated categorization.
              </p>
            </div>

            <button className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 transition-colors flex items-center mx-auto">
              <Search size={20} className="mr-2" />
              Search Documents
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchTagDocuments;
